import { importScreen } from '@infrastructure/splitting';

const BriefingForm = importScreen(() => import('./containers'));

export { BriefingForm };
